import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";



import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }


    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.roles.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Rol"}
                buttonIcon={"fa fa-search fa-lg"}
                
                saveButton={false}
                closeButton={true}>
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Proyectos_Roles/Detail.js